import React from 'react'
import 'stylesheets/TimerAppStyles/TodosLoading.css'


const TodosLoading = () => {
    return (
        <li className='todo-item'>
            <div className='todo-info'>
                <div className='todo-text'>
                    <div className='skeleton skeleton-text'></div>
                    <div className='skeleton skeleton-text'></div>
                </div>
                <div className='todo-category'>
                    <div className='skeleton skeleton-text'></div>
                </div>
                <div className='todo-intesity'>
                    <div className='skeleton skeleton-text'></div>
                </div>
            </div>
        </li>
    )
}

export { TodosLoading }